import {gql} from "@apollo/client";
import {client} from "graphql/client";

export const GET_ACCOUNT_WAREHOUSE_OPERATOR_BY_ACCOUNT_ID = gql`
    query GetAccountWarehouseOperatorByAccountId($accountId: Long!) {
        getAccountWarehouseOperatorByAccountId(accountId: $accountId) {
            id
            accountId
            warehouseId
        }
    }
`;

export interface AccountWarehouseOperatorType {
    id: number;
    accountId: number;
    warehouseId: number;
}

export interface GetAccountWarehouseOperatorByAccountIdQueryVariables {
    accountId: number;
}

export interface GetAccountWarehouseOperatorByAccountIdQuery {
    getAccountWarehouseOperatorByAccountId: AccountWarehouseOperatorType;
}

export const getAccountWarehouseOperatorByAccountId = async (accountId: number): Promise<AccountWarehouseOperatorType> => {
    const {data} = await client.query<GetAccountWarehouseOperatorByAccountIdQuery, GetAccountWarehouseOperatorByAccountIdQueryVariables>({
        query: GET_ACCOUNT_WAREHOUSE_OPERATOR_BY_ACCOUNT_ID,
        variables: {accountId}
    });
    return data.getAccountWarehouseOperatorByAccountId;
};  